import { createSlice } from "@reduxjs/toolkit";
import { updatePaymentInvoice, updatePaymentInvoiceStatus, getPaymentInvoiceById, searchPaymentInvoice, downloadInvoicePdf } from "../api/invoice";

interface UsersState {
    loading: boolean;
    currentRequestId: undefined | string;
    userData: any;
    error: any;
}

const initialState = {
    loading: false,
    currentRequestId: undefined,
    userData: null,
    error: null,
} as UsersState;

export const paymentInvoiceSlice = createSlice({
    name: 'paymentInvoice',
    initialState,
    reducers: {
        resetPaymentInvoice: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(updatePaymentInvoice.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(updatePaymentInvoice.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(updatePaymentInvoice.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(updatePaymentInvoiceStatus.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(updatePaymentInvoiceStatus.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(updatePaymentInvoiceStatus.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(searchPaymentInvoice.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(searchPaymentInvoice.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(searchPaymentInvoice.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(getPaymentInvoiceById.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(getPaymentInvoiceById.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(getPaymentInvoiceById.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(downloadInvoicePdf.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(downloadInvoicePdf.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(downloadInvoicePdf.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
    }
})

export const { resetPaymentInvoice } = paymentInvoiceSlice.actions;

export default paymentInvoiceSlice.reducer;
